module.exports = __webpack_public_path__ + "static/media/icon-supply-levels--dark-gray.22b85f42.svg";